const HAS_SEEN_TURN_INTO_VIDEO_TOOLTIP_LOCAL_STORAGE_KEY = 'pmw_ai_chat_seen_turn_into_video_tooltip';

export const hasUserSeenAiChatTurnIntoVideoTooltip = async (): Promise<boolean> => {
  if (getHasSeenTurnIntoVideoTooltipFromLocalStorage()) {
    return true;
  }

  if (!window.PMW.isUserLoggedIn()) {
    return false;
  }

  try {
    const response = (await window.PMW.readLocal('ai/hasUserSeenAiChatTurnIntoVideoTooltip')) as {hasSeen: boolean};
    if (response.hasSeen) {
      setHasSeenTurnIntoVideoTooltipInLocalStorage();
    }
    return response.hasSeen;
  } catch {
    return false;
  }
};

export const markAiChatTurnIntoVideoTooltipAsSeen = async (): Promise<void> => {
  setHasSeenTurnIntoVideoTooltipInLocalStorage();

  if (!window.PMW.isUserLoggedIn()) {
    return;
  }

  try {
    await window.PMW.writeLocal('ai/markAiChatTurnIntoVideoTooltipAsSeen');
  } catch {
    // best-effort; ignore failures
  }
};

function getHasSeenTurnIntoVideoTooltipFromLocalStorage(): boolean {
  try {
    return localStorage.getItem(HAS_SEEN_TURN_INTO_VIDEO_TOOLTIP_LOCAL_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function setHasSeenTurnIntoVideoTooltipInLocalStorage(): void {
  try {
    localStorage.setItem(HAS_SEEN_TURN_INTO_VIDEO_TOOLTIP_LOCAL_STORAGE_KEY, '1');
  } catch {
    // ignore quota / private-browsing failures
  }
}
